import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import useBoolean from 'src/hooks/useBoolean';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { GLPeriodDropdownChildren } from 'src/utils/transformation';
import { checkbookBalanceTitle } from './CheckbookHoldAmountTable';
import TransactionTable from './TransactionTable';

const ViewCheckbookTransactionLog = () => {
  const { t, dropDownPeriodValue, glPeriodIdByPeriod } = useViewCheckbook();
  const { value: openViewLogModal, toggle: toggleViewLogModal } = useBoolean();
  return (
    <>
      <Button color="secondary" onClick={toggleViewLogModal}>
        View All Transaction Logs
      </Button>
      <Dialog
        width="80%"
        id="modal"
        title={checkbookBalanceTitle(
          dropDownPeriodValue || ({} as GLPeriodDropdownChildren),
          t,
          undefined,
          'allLog'
        )}
        open={openViewLogModal}
        onClose={toggleViewLogModal}
      >
        <TransactionTable glPeriodId={glPeriodIdByPeriod} />
        <DialogActionsBar>
          <div className="flex justify-end">
            <Button onClick={toggleViewLogModal} color="info">
              {t('Close')}
            </Button>
          </div>
        </DialogActionsBar>
      </Dialog>
    </>
  );
};

export default ViewCheckbookTransactionLog;
